import React from 'react';
import Component from '@vfuk/core-paragraph';
const Paragraph = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Paragraph;
